import { render, staticRenderFns } from "./CreateBot.vue?vue&type=template&id=513cfe75&scoped=true&"
import script from "./CreateBot.vue?vue&type=script&lang=js&"
export * from "./CreateBot.vue?vue&type=script&lang=js&"
import style0 from "./CreateBot.vue?vue&type=style&index=0&id=513cfe75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513cfe75",
  null
  
)

export default component.exports